import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const ImpactASPlusPortalPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO 
        title="Impact AS Plus™ Login | Leadership Diagnostics Portal"
        description="Secure access to the Impact AS Plus™ platform for leadership diagnostics, coaching programmes, and insight reporting."
      />
      <Header />
      
      {/* Main Content - Iframe Container */}
      <main className="flex-1 pt-20">
        <div className="w-full h-[calc(100vh-80px)]">
          <iframe
            src="https://impactasportal.com/login"
            title="Impact AS Plus Portal"
            className="w-full h-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </main>
    </div>
  );
};

export default ImpactASPlusPortalPage;
